import { createContext } from 'react';
import { Theme } from 'src/lib/theme/types';
import * as theme from 'src/styles/theme';

const ThemeContext = createContext<Theme>(theme.main);

const { Provider: ThemeProvider } = ThemeContext;

export { ThemeContext, ThemeProvider };
